import React from 'react';
import { DynamicCatalogBuilder } from '../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
var CQAFailFailureReportsCatlog = function () {
    var columns = [{
            field: 'Srno',
            headerName: 'Sr. no.',
            headerAlign: 'center',
            minWidth: 100,
            align: 'center'
        }, {
            type: 'string',
            field: 'State',
            headerName: 'State',
            minWidth: 300,
            flex: 1
        }, {
            field: 'Intensity',
            headerName: 'Intensity',
            minWidth: 300,
            flex: 1
        }, {
            field: 'FRs',
            headerName: 'No of FRs',
            minWidth: 300,
            flex: 1
        }];
    return /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: columns,
        rows: [{
                id: 1,
                Srno: '1',
                State: 'Maharashtra',
                Intensity: '9',
                FRs: '9'
            }, {
                id: 2,
                Srno: '2',
                State: 'Maharashtra',
                Intensity: '9',
                FRs: '9'
            }],
        dataGridProps: {
            hideFooter: true,
            sx: {
                borderRadius: 0,
                borderLeft: 'none',
                borderRight: 'none',
                borderBottom: 'none'
            }
        }
    });
};
export default CQAFailFailureReportsCatlog;
